import {ImmutableStore} from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';
import moment from 'moment';
import { startOfDay } from '../utils/Date';

function defaultState() {
  return {
    sourceConversationData: [],
    sourceData: [],
    historyData: [],
    selectedConversationKey: 'conversationScore',
    guideType: 'both',
    loading: false,
    interval: 0,
    actionHistoryType: 'percentage',
    customerType: 'both'
  };
}

class OnlinePerformanceStore extends ImmutableStore {
  static storeName = 'OnlinePerformanceStore';

  static handlers = {
    [Actions.ONLINE_PERFORMANCE__DATA_LOAD_STARTED]: 'handleOnlinePerformanceDataChanged',
    [Actions.ONLINE_PERFORMANCE__DATA_LOADED]: 'handleOnlinePerformanceDataChanged',
    [Actions.ONLINE_PERFORMANCE__QUERY_CHANGED]: 'handleOnlinePerformanceQueryChanged',
    [Actions.ONLINE_PERFORMANCE__INTERVAL_CHANGED]: 'handleIntervalChanged'
  };

  constructor(dispatcher) {
    super(dispatcher);

    const now = startOfDay();
    const before = startOfDay().subtract(1, 'month');

    this.startDate = before.toDate();
    this.endDate = now.toDate();
    this.setState(defaultState());
  }

  handleOnlinePerformanceQueryChanged(query) {
    const defaults = defaultState();
    const {
      startDate = startOfDay().subtract(1, 'month'),
      endDate = startOfDay(),
      selectedConversationKey = defaults.selectedConversationKey,
      selectedSource,
      guideType = defaults.guideType,
      customerType = defaults.customerType,
      actionHistoryType = defaults.actionHistoryType
    } = query;

    this.mergeState({
      selectedSource,
      selectedConversationKey,
      guideType,
      actionHistoryType,
      customerType
    });

    if (startDate || endDate) {
      this.startDate = startDate ? new Date(startDate) : this.startDate;
      this.endDate = endDate ? new Date(endDate) : this.endDate;
      this.emitChange();
    }
  }

  handleOnlinePerformanceDataChanged(payload) {
    const {sourceData, loading = false, historyData} = payload;

    console.info('Updating leaderboard store state', payload);

    const state = {
      loading
    };

    if (sourceData) {
      state.sourceData = sourceData;
      const selectedSource = this.getSelectedSource();
      if (selectedSource && !sourceData.find(source => source.key === selectedSource)) {
        state.selectedSource = null;
      }
    }

    if (historyData) {
      historyData.forEach(d => {
        d.day = d.day || d.date;
        d.timestamp = moment().year(d.year).dayOfYear(d.day).toDate();
      });
      state.historyData = historyData;
    }

    this.mergeState(state);
  }

  handleIntervalChanged(left) {
    let interval = this.get('interval');
    if (left) {
      interval++;
    } else {
      interval--;
    }

    if (interval >= 0 && interval < 8) {
      this.mergeState({
        interval
      });
    }
  }

  getInterval() {
    return this.get('interval');
  }

  getSelectedConversationKey() {
    return this.get('selectedConversationKey');
  }

  getSelectedSource() {
    return this.get('selectedSource');
  }

  getSourceData() {
    return this.get('sourceData').toJS();
  }

  getHistoryData() {
    return this.get('historyData').toJS();
  }

  getActionHistoryType() {
    return this.get('actionHistoryType');
  }

  getSelectedDateRange() {
    return {
      start: this.startDate,
      end: this.endDate
    };
  }

  getCustomerType() {
    return this.get('customerType');
  }

  getGuideType() {
    return this.get('guideType');
  }

  isLoading() {
    return this.get('loading');
  }

  rehydrate(state) {
    state._state.historyData.forEach(e => {
      e.timestamp = new Date(e.timestamp);
    });
    super.rehydrate(state._state);

    this.startDate = new Date(state.startDate);
    this.endDate = new Date(state.endDate);
  }

  dehydrate() {
    return {
      _state: this._state,
      startDate: this.startDate,
      endDate: this.endDate
    };
  }
}

export default OnlinePerformanceStore;



// WEBPACK FOOTER //
// ./src/stores/OnlinePerformanceStore.js